import { computed } from 'vue';
import { useStore } from '@/store';

type TutorialIntroOptions = {
  introStepsDefault: Record<number, string>;
  quickStartSection: string;
};

export const useTutorialIntro = (getOptions: () => TutorialIntroOptions) => {
  const store = useStore();
  const introSteps = computed(() => {
    const { introStepsDefault, quickStartSection } = getOptions();

    return store.tutorial.quickStartSection === quickStartSection
      ? introStepsDefault
      : {};
  });

  const getIntroParams = (step: number) => {
    const stepIntro = introSteps.value[step];

    if (stepIntro) {
      return {
        'data-step': step,
        'data-intro': stepIntro,
      };
    }

    return {};
  };

  return {
    introSteps,
    getIntroParams,
  };
};
